import { ModeCategory } from '@commutifi/modes'
import { CombinedModes } from '@commutifi-fe/constants'
import React from 'react'

// Thanks to Kent C. Dodds for the inspiration:
// https://kentcdodds.com/blog/compound-components-with-react-hooks
export const ModeCardsSelectorContext = React.createContext<IModeCardsSelectorContext | null>(null)

export const useModeCardsSelectorContext = () => {
  const context = React.useContext(ModeCardsSelectorContext)
  if (!context) {
    throw new Error(
      'DriveAndTransit or MixedModes compound components cannot be rendered outside the ModeCardsSelector component'
    )
  }
  return context
}

export interface IModeCardsSelectorContext {
  onSelect: (e: React.MouseEvent, category: ModeCategory | CombinedModes) => void
  showDropdownOptionsCount?: boolean
}
